<script setup lang="ts">
withDefaults(defineProps<{
  as?: string
  variant?: 'primary' | 'secondary' | 'quiet' | 'icon'
  type?: 'button' | 'submit' | 'reset'
}>(), { as: 'button', variant: 'primary', type: 'button' })
</script>

<template>
  <component :is="as" class="vf-action-button" :class="`vf-action-button--${variant}`" :type="as === 'button' ? type : undefined">
    <slot />
  </component>
</template>
